import { DocumentImage } from '@containers/scalable-document-list/document-image';
import { ContainingImage } from '@screens/review-section2/document-review/styles';
import { IDocumentReviewStore } from '@stores/onboarding-review/document-review-store';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface InteractableDocumentProps {
    store: IDocumentReviewStore;
    document: DocumentImage;
}

// disabled rotation interaction for now
const InteractableDocument = observer((props: InteractableDocumentProps) => {
    const {
        document
    } = props;

    return (
        <ContainingImage src={document.dataUrl} />
    );
});

export default InteractableDocument;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/interactable-document.tsx